@if (inline) {
  @if (gotDgProperties) {
    <app-page-comp-header
      [hierarchyFormatting]="true"
      [initialCompanyId]="initialCompanyId"
      [showCompanyDropdown]="true"
      [title]="formTitle"
      (companyDropDownChange)="companyDropDownOnChange($event)"
    ></app-page-comp-header>

    <div class="compose-inline compose-modal-wide">
      <ng-container *ngTemplateOutlet="composeBody"></ng-container>
    </div>
  }
} @else {
  <ng-template #communicationComposeModalForm role="document" let-modal>

    <app-modal-comp-header
      [companyDropdownLabelTop]="false"
      [hierarchyFormatting]="true"
      [initialCompanyId]="initialCompanyId"
      [showClock]="true"
      [showCompanyDropdown]="true"
      [title]="formTitle"
      (cancelButtonOnClick)="composeFormCancel()"
      (companyDropDownChange)="companyDropDownOnChange($event)"
    ></app-modal-comp-header>

    <ng-container *ngTemplateOutlet="composeBody"></ng-container>

  </ng-template>
}

<ng-template #composeBody>
  <form (ngSubmit)="composeFormSubmit()" [formGroup]="composeForm" class="tablelist-form compose-form" autocomplete="off">
    <div class="modal-body">

      <div class="compose-layout">

        <div class="compose-left">

          @if (!hideChannelPanel) {
            <label class="form-label">Delivery Channels</label>
          }
          <div class="mb-3" [class.d-none]="hideChannelPanel">
          <div class="compose-channels" [style.grid-template-columns]="'repeat(' + shownChannelCount + ', 1fr)'">

            @if (showChannelInApp) {
              <label class="compose-channel"
                     [class.is-active]="formOfCompose['channelInApp'].value===true"
                     [class.is-disabled]="formOfCompose['channelInApp'].disabled">
                <i class="bi bi-app-indicator compose-channel-icon"></i>
                <span class="compose-channel-label">In-App</span>
                <div class="form-check form-switch form-switch-md mb-0">
                  <input class="form-check-input" type="checkbox" role="switch" id="channelInApp-field" formControlName="channelInApp" (change)="onChannelToggled()">
                </div>
              </label>
            }

            @if (showChannelSms) {
              <label class="compose-channel"
                     [class.is-active]="formOfCompose['channelSms'].value===true"
                     [class.is-disabled]="formOfCompose['channelSms'].disabled"
                     [ngbTooltip]="smsChannelReason"
                     [disableTooltip]="smsChannelAvailable">
                <i class="bi bi-chat-dots compose-channel-icon"></i>
                <span class="compose-channel-label">
                  SMS
                  @if (!smsChannelAvailable) { <i class="bx bx-info-circle text-warning"></i> }
                </span>
                <div class="form-check form-switch form-switch-md mb-0">
                  <input class="form-check-input" type="checkbox" role="switch" id="channelSms-field" formControlName="channelSms" (change)="onChannelToggled()">
                </div>
              </label>
            }

            @if (showChannelEmail) {
              <label class="compose-channel"
                     [class.is-active]="formOfCompose['channelEmail'].value===true"
                     [class.is-disabled]="formOfCompose['channelEmail'].disabled"
                     [ngbTooltip]="emailChannelReason"
                     [disableTooltip]="emailChannelAvailable">
                <i class="bi bi-envelope compose-channel-icon"></i>
                <span class="compose-channel-label">
                  Email
                  @if (!emailChannelAvailable) { <i class="bx bx-info-circle text-warning"></i> }
                </span>
                <div class="form-check form-switch form-switch-md mb-0">
                  <input class="form-check-input" type="checkbox" role="switch" id="channelEmail-field" formControlName="channelEmail" (change)="onChannelToggled()">
                </div>
              </label>
            }

          </div>

          @if (formSubmitted && noChannelSelected) {
            <div class="text-danger small mt-1">Please select at least one delivery channel.</div>
          }
          </div>

          <div class="compose-panel mb-3">
            <div class="compose-panel-head d-flex align-items-center justify-content-between">
              <span class="compose-panel-title">
                <i class="bi bi-people-fill me-1"></i>Selected Recipients
                @if (selectedRecipientCount>0) { <span class="badge bg-info-subtle text-info ms-1">{{selectedRecipientCount}}</span> }
              </span>
              @if (selectedRecipientCount>0) {
                <button type="button" class="btn btn-link btn-sm p-0 text-decoration-none" (click)="clearAllRecipients()">Clear all</button>
              }
            </div>
            @if (selectedRecipientCount<=0) {
              <div class="text-muted small mt-1">No users selected</div>
            }
            @if (selectedRecipientCount>0) {
              <div class="compose-chips">
                @for (recipient of selectedRecipients; track recipient.id) {
                  <span class="compose-chip">
                    {{recipientFullName(recipient)}}
                    <i class="bi bi-x-lg compose-chip-x" (click)="removeRecipient(recipient)"></i>
                  </span>
                }
              </div>
            } @else {
              <div class="compose-empty">
                <i class="bi bi-person-plus d-block mb-1"></i>
                Tick recipients in the list to add them here
              </div>
            }
            @if (formSubmitted && selectedRecipientCount<=0) {
              <div class="text-danger small mt-2">Please select at least one recipient.</div>
            }
          </div>

          <div class="compose-panel compose-fields mb-3" [class.has-schedule]="scheduleForLater">

            <div class="compose-fields-head">
              <span class="compose-fields-icon">
                <i class="bi bi-pencil-fill"></i>
              </span>
              <span class="compose-fields-heading">
                <span class="compose-fields-title">Compose Message</span>
              </span>
            </div>

            @if (showTemplateSelector) {
              <div class="mb-3">
                <label for="composeTemplate-field" class="form-label">Template</label>
                <div class="input-group">
                  <select
                    class="form-select"
                    id="composeTemplate-field"
                    [(ngModel)]="selectedTemplateId"
                    [ngModelOptions]="{ standalone: true }"
                    (ngModelChange)="onTemplateChange()"
                  >
                    <option [ngValue]="undefined"></option>
                    @for (object of composeTemplates; track object.id) {
                      <option [ngValue]="object.id">{{object.name}}</option>
                    }
                  </select>
                  <div #templateDropdown class="dropdown" [class.show]="templateDropdownOpen">
                    <button
                      [attr.aria-expanded]="templateDropdownOpen"
                      class="btn btn-success dropdown-toggle"
                      type="button"
                      (click)="toggleTemplateDropdown()"
                    >
                      <i class="icon nav-icon ri-settings-2-line"></i>
                    </button>
                    <ul class="dropdown-menu dropdown-menu-end" [class.show]="templateDropdownOpen">
                      <li><button type="button" class="dropdown-item" (click)="openComposeTemplate(true)">Create New Template</button></li>
                      <li><button type="button" class="dropdown-item" [disabled]="!canEditTemplate()" (click)="openComposeTemplate(false)">Edit Selected Template</button></li>
                    </ul>
                  </div>
                </div>
              </div>
            }

            @if (!isSmsOnly) {
              <div class="mb-3">
                <label for="communicationTypeId-field" class="form-label">Communication Type</label>
                <select
                  class="form-select"
                  name="communicationTypeId-field"
                  id="communicationTypeId-field"
                  formControlName="communicationTypeId"
                  [ngClass]="{ 'is-invalid': formSubmitted && formOfCompose['communicationTypeId'].errors }"
                >
                  <option selected></option>
                  @for (object of getDropdownDataObjectArray('communicationTypeId'); track object.id) {
                    <option [ngValue]="object.id">{{object.description}}</option>
                  }
                </select>
                <div class="invalid-feedback">A value is required</div>
              </div>
            }

            @if (!isSmsOnly) {
              <div class="mb-3">
                <label for="subject-field" class="form-label">Subject</label>
                <input autocomplete="no-fill" type="text" id="subject-field" class="form-control" placeholder="" formControlName="subject" data-lpignore="true"
                       [ngClass]="{ 'is-invalid': formSubmitted && formOfCompose['subject'].errors }" />
                @if (formOfCompose['subject'].hasError('maxlength')) {
                  <div class="invalid-feedback">Maximum length of {{subjectMaxLength}} characters has been exceeded</div>
                } @else {
                  <div class="invalid-feedback">A value is required</div>
                }
                <div class="text-muted small mt-1">Subjects will not show in SMS messages</div>
              </div>
            }

            <div class="mb-0 compose-message" [class.is-tall]="!scheduleForLater">
              <label for="message-field" class="form-label">Message</label>
              <textarea
                class="form-control"
                data-lpignore="true"
                formControlName="message"
                id="message-field"
                [ngClass]="{ 'is-invalid': formSubmitted && formOfCompose['message'].errors }"
                placeholder=""
                rows="5"
              >
              </textarea>
              <div class="invalid-feedback">A value is required</div>
            </div>

            <div class="compose-send-row">
              <button type="button" class="btn btn-success compose-send-btn" id="send-btn" [disabled]="isSending" (click)="composeFormSubmit(false)">
                @if (isSending) {
                  <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                  {{scheduleForLater ? 'Scheduling...' : 'Sending...'}}
                } @else {
                  <i class="bi me-2" [ngClass]="scheduleForLater ? 'bi-clock-history' : 'bi-send'"></i>
                  {{scheduleForLater ? 'Schedule' : 'Send'}}
                }
              </button>
              @if (!inline) {
                <button type="submit" class="btn btn-soft-success compose-send-btn" id="send-close-btn" [disabled]="isSending">
                  @if (isSending) {
                    <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    {{scheduleForLater ? 'Scheduling...' : 'Sending...'}}
                  } @else {
                    <i class="bi me-2" [ngClass]="scheduleForLater ? 'bi-clock-history' : 'bi-send'"></i>
                    {{scheduleForLater ? 'Schedule & Close' : 'Send & Close'}}
                  }
                </button>
              }
            </div>

          </div>

          <div class="compose-bottom-switches compose-panel">
            <div class="d-flex align-items-center gap-4">
              <div class="form-check form-switch form-switch-md mb-0">
                <input class="form-check-input" type="checkbox" role="switch" id="scheduleForLater-field" formControlName="scheduleForLater"
                       (change)="scheduleForLaterChanged($any($event.target).checked)">
                <label class="form-check-label" for="scheduleForLater-field">Schedule for later</label>
              </div>
            </div>

            @if (scheduleForLater) {
              <div class="compose-schedule is-open mt-2">
                <div class="text-muted small mb-2">
                  Scheduled messages are sent within approximately five minutes of the chosen time, which is UTC. SMS allowance is not reserved now - it is counted after it is sent.
                </div>
                <div class="row">
                  <div [class.col-6]="showEndDate" [class.col-12]="!showEndDate">
                    <app-dropdown-date
                      [enableTime]="true"
                      [initialDate]="startDate"
                      title="Send Date & Time (UTC)"
                      (selectOnChangeEvent)="startDateChanged($event)"
                    ></app-dropdown-date>
                  </div>
                  @if (showEndDate) {
                    <div class="col-6">
                      <app-dropdown-date
                        [allowUndefinedInitialDate]="true"
                        [initialDate]="endDate"
                        title="End Date"
                        (selectOnChangeEvent)="endDateChanged($event)"
                      ></app-dropdown-date>
                    </div>
                  }
                </div>
              </div>
            }
          </div>

        </div>

        <div class="compose-right">

          <div class="compose-allowance mb-3">
            <div class="d-flex align-items-center justify-content-between flex-wrap gap-3">
              <span class="compose-allowance-title">
                <!--
                @if (curUser.currencySymbol) {
                  <span class="compose-allowance-currency me-1">{{curUser.currencySymbol}}</span>
                } @else {
                  <i class="bi bi-coin me-1"></i>
                }
                -->
                <i class="bi bi-chat-dots me-1"></i>
                SMS Allowance - This Month
                @if (smsAllowance.companyName) {
                  <span class="compose-allowance-source ms-1">({{smsAllowance.companyName}})</span>
                }
              </span>
              <div class="compose-allowance-stats">
                <div class="compose-stat">
                  <span class="compose-stat-value">{{smsAllowance.totalMonthlyQuantity ?? 0}}</span>
                  <span class="compose-stat-label">Allowance</span>
                </div>
                <div class="compose-stat">
                  <span class="compose-stat-value" [ngClass]="(smsAllowance.remainingMonthlyQuantity ?? 0)<=0 ? 'text-danger' : 'text-success'">{{smsAllowance.remainingMonthlyQuantity ?? 0}}</span>
                  <span class="compose-stat-label">Remaining</span>
                </div>
                <div class="compose-stat">
                  <span class="compose-stat-value text-danger">{{smsAllowance.usedMonthlyQuantity ?? 0}}</span>
                  <span class="compose-stat-label">Used</span>
                </div>
              </div>
            </div>
            @if (smsAllowanceExhausted) {
              <div class="compose-allowance-warning mt-2">
                <i class="bi bi-exclamation-triangle-fill me-2"></i>
                <span>No SMS allowance. SMS delivery channel is disabled.</span>
              </div>
            } @else {
              <div class="compose-allowance-bar mt-2">
                <div class="compose-allowance-fill" [style.width.%]="smsAllowanceUsedPercent"></div>
              </div>
              <div class="compose-allowance-pct">{{smsAllowanceUsedPercent}}% used</div>
            }
            @if (showTwilioDisabledWarning) {
              <div class="compose-allowance-warning mt-2">
                <i class="bi bi-exclamation-triangle-fill me-2"></i>
                @if (!supplierMessagingEnabled) {
                  <span>
                    No SMS can be sent: Twilio is disabled and SureSIM messaging is disabled.
                    @if (showSmsProviderOverride) { Only a forced SureSIM send, to a recipient with a Live SureSIM SIM, will be delivered. }
                  </span>
                } @else {
                  <span>Twilio is disabled. SMS will only be sent through SureSIM, to recipients with a Live SureSIM SIM. Other recipients will fail.</span>
                }
              </div>
            }
          </div>

          @if (showSmsProviderOverride && formOfCompose['channelSms'].value===true) {
            <div class="compose-panel compose-sms-provider mb-3">
              <label class="form-label mb-1">SMS Provider</label>
              <div class="d-flex align-items-center gap-3">
                <div class="form-check mb-0">
                  <input class="form-check-input" type="radio" id="smsProvider-default" formControlName="smsProviderOverride" [value]="SmsProviderOverride.Default">
                  <label class="form-check-label" for="smsProvider-default">Default</label>
                </div>
                <div class="form-check mb-0">
                  <input class="form-check-input" type="radio" id="smsProvider-suresim" formControlName="smsProviderOverride" [value]="SmsProviderOverride.SureSim">
                  <label class="form-check-label" for="smsProvider-suresim">SureSIM</label>
                </div>
                <div class="form-check mb-0" ngbTooltip="Twilio is disabled" [disableTooltip]="twilioEnabled">
                  <input class="form-check-input" type="radio" id="smsProvider-twilio" formControlName="smsProviderOverride" [value]="SmsProviderOverride.Twilio" [attr.disabled]="twilioEnabled ? null : true">
                  <label class="form-check-label" for="smsProvider-twilio">Twilio</label>
                </div>
                <div class="form-check mb-0" ngbTooltip="Twilio is disabled" [disableTooltip]="twilioEnabled">
                  <input class="form-check-input" type="radio" id="smsProvider-both" formControlName="smsProviderOverride" [value]="SmsProviderOverride.Both" [attr.disabled]="twilioEnabled ? null : true">
                  <label class="form-check-label" for="smsProvider-both">Both</label>
                </div>
              </div>
              <div class="text-muted small mt-1">Default uses standard routing. 'SureSIM' or 'Twilio' uses only that provider, with no fallback. 'Both' sends two copies - one through each provider.</div>
              @if (smsAllowanceShortfall>0) {
                <div class="text-danger small mt-1">
                  This send needs {{smsCreditsRequired}} SMS credits but only {{smsAllowance.remainingMonthlyQuantity}} remain this month. The messages beyond the allowance will fail.
                </div>
              }
            </div>
          }

          <div class="compose-grid-shell">
            <label class="form-label">Recipients</label>
            <div class="compose-grid-body">
              @if (gotDgProperties) {
                <app-grid-view #recipientsGrid
                  [apiPath]="dgApiPath"
                  [dgActionColumn]="dgActionColumn"
                  [dgColumns]="dgColumns"
                  [dgPopup]="dgPopup"
                  [dgProperties]="dgProperties"
                  (cellClick)="onRecipientCellClick($event)"
                  (checkbox0Change)="onCheckboxChange($event)"
                  (contentReady)="onGridContentReady()"
                ></app-grid-view>
              }
            </div>
          </div>

        </div>

      </div>

    </div>
    @if (!inline) {
      <div class="modal-footer">
        <div class="hstack gap-2 justify-content-end">
          <button type="button" class="btn btn-light" data-bs-dismiss="modal" (click)="composeFormCancel()">Close</button>
        </div>
      </div>
    }
  </form>
</ng-template>

<app-completed-modal-form #completedModalForm
  (modalClosed)="completedModalHasBeenClosed()"
></app-completed-modal-form>

<app-template-email-modal-form #emailTemplateModalForm
  label0Text="Subject text will not be sent to SMS receivers"
  title="Message Template"
  (emailTemplateModalFormClosed)="composeTemplateModalFormClosed($event)"
></app-template-email-modal-form>

<app-user-modal-form #userModalForm
  [initialInviewCompanyId]="initialCompanyId"
  (sureSimUserDataHasBeenSaved)="recipientUserDataHasBeenSaved($event)"
  (userFormCancelled)="recipientUserFormCancelled()"
></app-user-modal-form>

<app-warning-modal-form #warningModalForm
></app-warning-modal-form>
